import { BoxV2 as Box, Flex } from 'portal-commons';
import { FC } from 'react';

interface SectionItemProps {
  title?: string;
}

const SectionItem: FC<SectionItemProps> = ({ title, children }) => (
  <Flex
    sx={{
      flexDirection: 'column',
      gap: 'xxs',
      color: '#313129',
      fontWeight: 400,
      fontSize: 'H300',
      lineHeight: 'normal',
      wordBreak: 'break-all',
    }}
  >
    {title && (
      <Box
        sx={{
          color: '#74746B',
          fontSize: 'H200',
          textTransform: 'uppercase',
        }}
      >
        {title}
      </Box>
    )}
    {children || 'N/A'}
  </Flex>
);

export default SectionItem;
